import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Explorer from "./pages/Explorer";
import TripDetail from "./pages/TripDetail";
import Publish from "./pages/Publish";
import MonEspace from "./pages/MonEspace";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Faq from "./pages/Faq";
import Confiance from "./pages/Confiance";
import CaptainProfile from "./pages/CaptainProfile";
import Admin from "./pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Intercept Google OAuth callback before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/explorer" element={<Explorer />} />
        <Route path="/sortie/:tripId" element={<TripDetail />} />
        <Route path="/publier" element={<Publish />} />
        <Route path="/mon-espace" element={<MonEspace />} />
        <Route path="/connexion" element={<Login />} />
        <Route path="/inscription" element={<Register />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/confiance" element={<Confiance />} />
        <Route path="/capitaine/:userId" element={<CaptainProfile />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
